
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["sc-hIPkLu sZNIM",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 6v7H7.204L12 18.481 16.796 13H15V6H9zm-2 5V5a1 1 0 011-1h8a1 1 0 011 1v6h2c.86 0 1.318 1.012.753 1.659l-7 8a1 1 0 01-1.506 0l-7-8C3.682 12.012 4.141 11 5 11h2z","fill":"#2196F3"}})])
          )
        }
      }
    